import { useState, useRef, useEffect } from "react";

export default function CourseSelection({ data, courseSelection }) {
    const [selectedData, setSelectedData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isDone, setIsDone] = useState(false);
    const workerRef = useRef(null);

    const startSelection = () => {
        setIsLoading(true);
        if (workerRef.current) {
            workerRef.current.postMessage({ data, courseSelection });
        }
    }

    const onlyUnique = (value, index, self) => {
        return self.indexOf(value) === index;
    }

    useEffect(() => {
        workerRef.current = new Worker(new URL('./CourseSelectionWorker.js', import.meta.url));
        workerRef.current.onmessage = (event) => {
            console.log("Web worker message received:", event.data);
            if (event.data.stop) {
                setIsLoading(false);
                setIsDone(true);
            } else {
                setSelectedData(event.data);
            }
        }
        return () => {
            workerRef.current.terminate();
        }
    }, []);


    return (
        <div>
            <h2>Zuteilung</h2>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'start', width: '100%', justifyContent: 'space-between' }}>
            <div>
            <table style={{ padding: '20px', marginBottom: '20px' }}>
                <thead>
                    <tr>
                        <th>Kurs</th>
                        <th>Termin 1</th>
                        <th>Termin 2</th>
                        <th>Termin 3</th>
                    </tr>
                </thead>
                <tbody>
                    {courseSelection.map((course) => course.name).filter(onlyUnique).map((course, index) => (
                        <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#f2f2f2' : '#ffffff' }}>
                            <td>{course}</td>
                            <td>{selectedData?.courses?.filter(c => c.name === course && c.termin === 1).length > 0 ? `${selectedData?.courses?.filter(c=>c.name === course && c.termin === 1)[0]?.selected.length ?? "0"}` : "✘"}</td>
                            <td>{selectedData?.courses?.filter(c => c.name === course && c.termin === 2).length > 0 ? `${selectedData?.courses?.filter(c=>c.name === course && c.termin === 2)[0]?.selected.length ?? "0"}` : "✘"}</td>
                            <td>{selectedData?.courses?.filter(c => c.name === course && c.termin === 3).length > 0 ? `${selectedData?.courses?.filter(c=>c.name === course && c.termin === 3)[0]?.selected.length ?? "0"}` : "✘"}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <table style={{ padding: '20px', marginBottom: '20px' }}>
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Name</th>
                        <th>E-Mail</th>
                        <th>Termin 1</th>
                        <th>Termin 2</th>
                        <th>Termin 3</th>
                    </tr>
                </thead>
                <tbody>
                    {selectedData?.entries && selectedData.entries.sort((a,b) => a.id - b.id).map((entry, index) => (
                        <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#f2f2f2' : '#ffffff' }}>
                            <td style={{ paddingX: '10px'}}>{entry.id}</td>
                            <td style={{ paddingX: '10px'}}>{entry.name}</td>
                            <td style={{ paddingX: '10px'}}>{entry.eMail}</td>
                            <td style={{ paddingX: '10px'}}>{entry.selected1}</td>
                            <td style={{ paddingX: '10px'}}>{entry.selected2}</td>
                            <td style={{ paddingX: '10px'}}>{entry.selected3}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            </div>
            <div style={{ maxWidth: 'fit-content', marginLeft: '20px', marginTop: '20px' }}>
            <div>
                <button onClick={startSelection} disabled={isLoading} style={{ display: isDone ? 'none' : 'block' }}>Zuteilung starten</button>
            </div>
            <div>
                {isLoading ? <p>Berechne Zuteilung...</p> : null}
                {isDone ? <p>Zuteilung abgeschlossen!</p> : null}
            </div>
            </div>
        </div>
        </div>
    )
}